const DashboardColors = {
    MASTERY_BAR_BG: '#63A965',
    PRACTICE_BAR_BG: '#741A76',
    PRACTICE_GOAL_BAR_BG: '#B588B6',
    GOAL_BG: '#8F8F8F',
  };

  export default DashboardColors;